import React from 'react';
import {
    ButtonText,
    Header,
    Image,
    ImageContainer,
    Text,
    Wrapper,
} from '../../maintainance/index.styled';
import Button from 'src/common/refactoredComponents/button/Button';
import Home from 'src/assets/images/Home.svg';
import Forbidden from 'src/assets/images/Forbidden.svg';
import PageNotFound from 'src/assets/images/PageNotFound.svg';
import { ErrorContainer, Reason } from './index.styled';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';

const ForbiddenError = () => {
    const { state } = useLocation();
    const { t } = useTranslation();
    const defaultErrorDetails = {
        title: t('errorDetails.pageNotFound.title'),
        content: t('errorDetails.pageNotFound.content'),
        helpLineText: t('errorDetails.pageNotFound.helpLinetext'),
    };
    const errorDetails = state?.errorDetails || defaultErrorDetails;
    const isForbiddenError =
        errorDetails.title === t('errorDetails.forbidden.title') ||
        errorDetails.title === 'Forebidden!';
    const errorLogout = () => {
        // history.push('/');
        window.location.pathname = '/';
        // window.onbeforeunload = null;
        // localStorage.removeItem('lastSelDLPCalView');
        // localStorage.removeItem('userAuthenticated');
        // sessionStorage.removeItem('employeeRole');
        // // Logout depending SSO is enabled or disabled
        // if (process.env.ENABLE_SSO) {
        //     dispatch(logoutSSO(true));
        //     instance.logoutRedirect();
        // } else {
        //     dispatch(logoutHybrisAPI());
        // }
        // clearStorageBrowserClose(dispatch);
        // clearPersistStorage();
    };
    const lastWord =
        errorDetails.content?.split(' ')[
            errorDetails.content?.split(' ').length - 1
        ] || '';
    const mail =
        errorDetails.helpLineText?.split(' ')[
            errorDetails.helpLineText?.split(' ').length - 1
        ] || '';
    // useEffectWithErrorLogging(()=>{
    //     if (sessionStorage.getItem('employeeRole')) {
    //         setErrorDetails(
    //             isCorrectURL(
    //                 routes,
    //                 window.location.pathname,
    //                 EQUITY_USER_PAGE_VISIBILITY_RULE.filter(
    //                     (item) =>
    //                         item.role == sessionStorage.getItem('employeeRole')
    //                 )[0].urlAccess
    //             )
    //         );
    //     }
    // },[window.location.pathname]);
    return (
        <ErrorContainer>
            {/* <Headers/> */}
            <ImageContainer
                width={'338px'}
                height={'322px'}
                mbWidth={'228px'}
                mbHeight={'84px'}
            >
                <Image
                    src={isForbiddenError ? Forbidden : PageNotFound}
                    mbWidth={'80px'}
                    mbHeight={'80px'}
                    width={'215px'}
                    height={'285px'}
                ></Image>
            </ImageContainer>
            <Wrapper>
                <Header>
                    {t(
                        'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.biologicsUsed.yesTableHeader.medtronic'
                    )}
                </Header>
                <Reason>{errorDetails.title}</Reason>
                {isForbiddenError ? (
                    <Text>{errorDetails.content}</Text>
                ) : (
                    <Text>
                        {' '}
                        {`${errorDetails.content
                            ?.split(' ')
                            .slice(0, -1)
                            .join(' ')}\u00A0`}
                        <span
                            style={{
                                fontFamily: 'AvenirNextWorld Demi',
                                cursor: 'pointer',
                            }}
                            onClick={() => errorLogout()}
                        >{`${lastWord}.`}</span>
                    </Text>
                )}
                <Text>
                    {' '}
                    {`${errorDetails.helpLineText
                        ?.split(' ')
                        .slice(0, -1)
                        .join(' ')}\u00A0`}
                    <span>{`${mail}.`}</span>
                </Text>
                {errorDetails.title === t('errorDetails.pageNotFound.title') && (
                    <Button
                    id={'common-forbiddenErrorHomeButton'}
                        show={true}
                        width={'119px'}
                        height={'36px'}
                        //secondary
                        // variant={ButtonStyles?.secondary}
                        backgroundColor={'#140f4b'}
                        color={'#ffffff'}
                        border={'1px solid #ffffff'}
                        clicked={errorLogout}
                    >
                        <div
                            style={{
                                margin: '5px 10px 0 5px',
                                cursor: 'pointer',
                            }}
                        >
                            <img src={Home}></img>
                        </div>
                        <ButtonText>
                            {t(
                                'ConsignmentAdd.common.bundleItems.createTemplate.home'
                            )}
                        </ButtonText>
                    </Button>
                )}
            </Wrapper>
        </ErrorContainer>
    );
};
export default ForbiddenError;
